import {HttpClient, HttpErrorResponse} from '@angular/common/http';
import {inject, Injectable} from '@angular/core';
import {catchError, Observable} from 'rxjs';
import {ITmtErpSyncTimeline} from '../interfaces/tmt-erp-panel.interface';

@Injectable({
  providedIn: 'root',
})
export class TmtErpTimelineService {
  private readonly http = inject(HttpClient);

  getTimeline(salesOrderId: number): Observable<ITmtErpSyncTimeline> {
    return this.http.get<ITmtErpSyncTimeline>(`tmt/sales-orders/${salesOrderId}/erp-sync-timeline`)
      .pipe(catchError((error: HttpErrorResponse) => {
        throw new Error(error?.error?.detail || error?.message || 'Server error');
      }));
  }
}
